import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {CartService} from '../../services/cart.service';
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-calendar-cart',
  templateUrl: './calendar-cart.component.html',
  styleUrls: ['./calendar-cart.component.css']
})
export class CalendarCartComponent {
  selectedMonth: Date = new Date(); // Default month to display
  daysInMonth: { date: Date; events: any[] }[] = [];

  events: any[] = [
    // { date: new Date('2024-12-01'), title: 'DEL00QSQ67Q', description: '6E DEL-NAG 20:10 Mr. Ajay Sajwan 6E DEL-NAG 20:10 Mr. Ajay Sajwan' },
    // { date: new Date('2024-12-02'), title: 'DEL00NTVVJ', description: '6E DEL-MAA 07:15 Mr. Prabhat Pandey 6E DEL-NAG 20:10 Mr. Ajay Sajwan' },
    // { date: new Date('2024-12-11'), title: 'DEL00GPI3W', description: 'AI PNQ-DEL 07:40 Mr. Rajeev Gautam 6E DEL-NAG 20:10 Mr. Ajay Sajwan' },
    // { date: new Date('2024-12-30'), title: 'DEL00QG24FJ', description: '6E CCU-IXS 07:05 Mr. Surojit Das' },
  ];

  constructor(private toastMsgService:ToastmsgService,private CartService:CartService){
this.calendardata()
  }
  ngOnInit() {
    // this.generateDaysInMonth();
  }
  leadingEmptyCells: any[] = []; // Holds empty cells before the 1st day of the month

  generateDaysInMonth(): void {
    const month = this.selectedMonth.getMonth();
    const year = this.selectedMonth.getFullYear();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();

    this.leadingEmptyCells = Array(firstDay).fill(null);

    // Calculate the leading empty cells based on the first day
    this.leadingEmptyCells = Array(firstDay).fill(null);
    this.daysInMonth = Array.from({ length: daysInMonth }, (_, i) => {
      const date = new Date(year, month, i + 1);
      return { date, events: this.getEventsForDate(date) };
    });
  }
  formatDateToDDMMYY(val: Date) {
    let datepipe = new DatePipe("en");
    return datepipe.transform(val, "dd-MM-yyyy");
  }
  getEventsForDate(date: Date): any[] {

    return this.events.filter(event => event.date.toDateString() === date.toDateString());
  }
  monthYearControl = new FormControl();

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.monthYearControl.value || moment();
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.monthYearControl.setValue(ctrlValue);
    datepicker.close();
  }
  disabled:any

calendardata(){
  this.disabled=true
  this.events=[]
  //  this.request.month = date.toLocaleString('default', { month: 'long' }); // Month name
  //     this.request.year = date.getFullYear(); // Year
  let request:any={
    month:this.formattedDate.split(' ')[0],
    year:this.formattedDate.split(' ')[1]
  }
  this.CartService
  .calendar(request)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        let data:any=res
        this.selectedMonth=new Date(request.year+'-'+request.month+'-01')
        // this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});
// this.events=data?.body
function formatDateToDDMMYY(val: Date) {
  let datepipe = new DatePipe("en");
  return datepipe.transform(val, "HH:mm");
}
for(let item of data?.body){
  for(let Itineraries of  item.bookingOrder.airItineraries){
    let desc:any=[]
    let Passengers:any=''
    for(let Passenger of  Itineraries.orderPassengerDetails){

      Passengers+=Passenger?.title+` `+Passenger?.firstName+` `+Passenger?.lastName+`\n`

    }
console.log(Passengers)

if(Passengers){
  desc+=Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+formatDateToDDMMYY(Itineraries?.firstDeparture)+`\n`+Passengers+'\n'

}else{
  desc+=Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+formatDateToDDMMYY(Itineraries?.firstDeparture)+`\n`

}
   this.events.push({
    title:Itineraries?.orderUuid,
    date: new Date(Itineraries?.firstDeparture),
    
    description:desc})
  }
 

}

  this.generateDaysInMonth()
      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Get Data',msgTitle : "Warning", msgType : "W"});

      this.disabled=false

    }
  }
)
}

formatSummaryDate(val: any) {
  const timestamp = val;
  const date = new Date(timestamp);

  const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

  // const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short' };
  // const formattedDate = date.toLocaleDateString('en-GB', options).replace(',', '');
  const formattedTime = new Intl.DateTimeFormat('en-US', options).format(new Date());


  // console.log(formattedDate)
//  return formattedTime.replace(' ','-'); // Output: "17-Jun"
  return formattedTime; // Output: "17-Jun"

  
}
selectedDate: Date | null = new Date();
  formattedDate: string = moment(this.selectedDate).format('MM YYYY'); // Format the current date;

onMonthSelected(event: Date, datepicker: MatDatepicker<Date>) {
  this.selectedDate = event;
  this.formattedDate = moment(event).format('MM YYYY');
  datepicker.close();
  this.calendardata()

}

onDateChange(event: any) {
  this.formattedDate = moment(event.value).format('MM YYYY');
}

onModifyClick(id:any){
  // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
  // window.open(url);
  let url="/app/modify-cart?id="+id
  window.open(url)
}
}
